import { render, staticRenderFns } from "./tagItemTest.vue?vue&type=template&id=2a0a524c&scoped=true&"
import script from "./tagItemTest.vue?vue&type=script&lang=js&"
export * from "./tagItemTest.vue?vue&type=script&lang=js&"
import style0 from "./tagItemTest.vue?vue&type=style&index=0&id=2a0a524c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0a524c",
  null
  
)

export default component.exports